// ~/apps/themusicchurch-app/frontend/src/styles/theme.js

export const theme = {
    colors: {
        homeNavy: '#071c2d',
        homeGold: '#e4c28c',
        homeSurface: '#0d293b',
        homeText: '#c6d9e2',
        primary: '#2C3E50',      // Deep blue-gray from the building
        secondary: '#8B7355',    // Warm brown from wood textures
        accent: '#7FCDCD',       // Soft teal from stained glass
        light: '#F5F5F5',        // Light background
        dark: '#1A1A1A',         // Dark text
        darkBg: 'rgba(26, 26, 26, 0.9)', // Dark background with opacity
        white: '#FFFFFF',
        gray: {
            100: '#F8F9FA',
            200: '#E9ECEF',
            300: '#DEE2E6',
            400: '#CED4DA',
            500: '#ADB5BD',
            600: '#6C757D',
            700: '#495057',
            800: '#343A40',
            900: '#212529'
        }
    },
    fonts: {
        heading: "'Montserrat', sans-serif",
        body: "'Open Sans', sans-serif",
        serif: "'Crimson Text', serif"
    },
    fontSizes: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem'
    },
    breakpoints: {
        mobile: '320px',
        tablet: '768px',
        desktop: '1024px',
        wide: '1200px'
    },
    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        '2xl': '3rem',
        '3xl': '4rem',
        '4xl': '6rem'
    },
    shadows: {
        sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
    },
    transitions: {
        fast: '150ms ease-in-out',
        base: '250ms ease-in-out',
        slow: '350ms ease-in-out'
    }
}